/* src/app/components/menu-list-filters/menu-list-filters.component.scss */
.wrapper {
  width: 100%;
  padding: 20px;
  margin: 0 auto;
}
.wrapper .content-section {
  background: #F6F1EF;
  padding: 15px;
  border-radius: 26px;
}
.wrapper .title-wrapper {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 5px;
}
@media (width < 400px) {
  .wrapper .title-wrapper {
    flex-direction: column;
    align-items: start;
  }
}
.wrapper .title-wrapper .title {
  color: var(--color-black);
  font-family: AppFont, sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 16px;
}
.wrapper .title-wrapper .title-info {
  font-family: AppFont;
  font-size: 10px;
  text-transform: uppercase;
}
.wrapper .header-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.wrapper .header-block ion-icon {
  rotate: 180deg;
  transition: rotate 0.5s ease-in-out;
  z-index: 99;
  cursor: pointer;
}
.wrapper .header-block ion-icon.isOpen {
  rotate: 0deg;
}
.wrapper .filter_wrapper {
  width: 100%;
  border-radius: 26px;
  visibility: hidden;
  max-height: 0px;
  transition: opacity 0.2s ease-in-out;
  opacity: 0;
}
.wrapper .filter_wrapper.show-filters {
  visibility: visible;
  opacity: 1;
  max-height: fit-content;
}
.wrapper .filter_wrapper .filter_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0px 15px;
}
.wrapper .filter_wrapper .filter_item.bottom-line {
  border-bottom: 1px solid #ebdfda;
}
.wrapper .filter_wrapper .filter_item div {
  margin-right: 10px;
}
.wrapper .filter_wrapper .filter_item p {
  font-size: 14px;
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  text-transform: uppercase;
  border-radius: 26px;
}
.wrapper ion-button {
  margin-top: 10px;
  width: 100%;
}
ion-item {
  --background: transparent;
}
ion-toggle {
  --handle-background-checked: var(--primary-btn);
}
/*# sourceMappingURL=menu-list-filters.component.css.map */
